(function() {
  // Universal dropdown initialization function
  window.initCustomVariantDropdown = window.initCustomVariantDropdown || function(dropdownElement, imageSelector) {
    if (dropdownElement.dataset.dropdownInitialized === 'true') return;
    dropdownElement.dataset.dropdownInitialized = 'true';
    
    const trigger = dropdownElement.querySelector('[data-dropdown-trigger]');
    const menu = dropdownElement.querySelector('[data-dropdown-menu]');
    const options = dropdownElement.querySelectorAll('[data-dropdown-option]');
    const productId = dropdownElement.getAttribute('data-product-id');
    const location = dropdownElement.getAttribute('data-location');
    const dropdownType = dropdownElement.getAttribute('data-dropdown-type');
    
    let nativeSelect;
    if (dropdownType === 'cart-upsell') {
      nativeSelect = document.getElementById('CartSelector-' + productId);
    } else {
      nativeSelect = document.getElementById('SingleOptionSelector-' + location + '-' + productId);
    }
    
    const container = dropdownElement.closest(imageSelector || '.mini-product-card, .product-item, .mobile-product-item');
    const productImage = container ? container.querySelector('.mini-product-card__image, .product-image-mobile, .product-image') : null;
    
    // Initialize color circles on each option and trigger
    const triggerColor = trigger ? trigger.querySelector('[data-trigger-color]') : null;
    
    const setColorCircle = function(circle, hex, swatchImage) {
      if (!circle) return;
      if (hex) {
        circle.style.backgroundColor = hex;
        circle.style.backgroundImage = 'none';
      } 
      else if (swatchImage && swatchImage.includes('.png')) {
        circle.style.backgroundImage = "url('" + swatchImage + "')";
        circle.style.backgroundSize = 'cover';
      }
    };
    
    const initOptionColorCircles = function() {
      options.forEach(function(option) {
        const colorCircle = option.querySelector('[data-option-color]');
        const hex = option.getAttribute('data-color-metafield');
        const swatchImage = option.getAttribute('data-swatch-image');
        setColorCircle(colorCircle, hex, swatchImage);
      });
      
      if (triggerColor) {
        const selectedOption = Array.from(options).find(function(opt) { return opt.classList.contains('is-selected'); });
        if (selectedOption) {
          const hex = selectedOption.getAttribute('data-color-metafield');
          const swatchImage = selectedOption.getAttribute('data-swatch-image');
          setColorCircle(triggerColor, hex, swatchImage);
        } else {
          const swatchImage = triggerColor.getAttribute('data-swatch-image');
          setColorCircle(triggerColor, null, swatchImage);
        }
      }
    };
    
    initOptionColorCircles();
    
    if (!trigger || !menu || !nativeSelect) return;
    
    // Track focused option index for keyboard navigation
    let focusedIndex = -1;
    const optionsArray = Array.from(options);
    
    const updateFocusedOption = function(index) {
      // Remove focus from all
      options.forEach(function(opt) { opt.classList.remove('is-focused'); });
      
      if (index >= 0 && index < options.length) {
        focusedIndex = index;
        const focusedOption = optionsArray[focusedIndex];
        focusedOption.classList.add('is-focused');
        focusedOption.scrollIntoView({ block: 'nearest' });
        
        // Update aria-activedescendant
        const optionId = focusedOption.getAttribute('id');
        if (optionId) {
          trigger.setAttribute('aria-activedescendant', optionId);
        }
      } else {
        focusedIndex = -1;
        trigger.removeAttribute('aria-activedescendant');
      }
    };
    
    const selectOption = function(option) {
      if (!option) return;
      option.click();
    };
    
    const openDropdown = function() {
      if (dropdownElement.classList.contains('is-open')) return;
      trigger.click();
      // Focus the selected option or first option
      const selectedIndex = optionsArray.findIndex(function(opt) { return opt.classList.contains('is-selected'); });
      updateFocusedOption(selectedIndex >= 0 ? selectedIndex : 0);
    };
    
    const closeDropdown = function() {
      if (!dropdownElement.classList.contains('is-open')) return;
      
      dropdownElement.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.style.setProperty('opacity', '0', 'important');
      menu.style.setProperty('visibility', 'hidden', 'important');
      menu.style.setProperty('pointer-events', 'none', 'important');
      updateFocusedOption(-1);
      trigger.focus();
      
      setTimeout(function() {
        if (menu.parentNode === document.body) {
          dropdownElement.appendChild(menu);
        }
      }, 200);
    };
    
    // Keyboard navigation
    trigger.addEventListener('keydown', function(e) {
      const isOpen = dropdownElement.classList.contains('is-open');
      
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (!isOpen) {
            openDropdown();
          } else if (focusedIndex >= 0) {
            selectOption(optionsArray[focusedIndex]);
          }
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (!isOpen) {
            openDropdown();
          } else {
            updateFocusedOption(Math.min(focusedIndex + 1, options.length - 1));
          }
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (!isOpen) {
            openDropdown();
          } else {
            updateFocusedOption(Math.max(focusedIndex - 1, 0));
          }
          break;
        case 'Escape':
          if (isOpen) {
            e.preventDefault();
            closeDropdown();
          }
          break;
        case 'Home':
          if (isOpen) {
            e.preventDefault();
            updateFocusedOption(0);
          }
          break;
        case 'End':
          if (isOpen) {
            e.preventDefault();
            updateFocusedOption(options.length - 1);
          }
          break;
        case 'Tab':
          if (isOpen) {
            closeDropdown();
          }
          break;
      }
    });
    
    const positionMenu = function() {
      const triggerRect = trigger.getBoundingClientRect();
      const drawer = dropdownElement.closest('.drawer, .drawer__scrollable, [class*="drawer"]');
      const modal = dropdownElement.closest('[class*="modal"], [class*="hotspot"]');
      const containerEl = drawer || modal;
      
      let boundaryLeft = 10;
      let boundaryRight = window.innerWidth - 10;
      
      if (containerEl) {
        const containerRect = containerEl.getBoundingClientRect();
        boundaryLeft = containerRect.left + 10;
        boundaryRight = containerRect.right - 10;
      }
      
      const spaceRight = boundaryRight - triggerRect.left;
      let menuWidth = Math.max(150, Math.min(triggerRect.width, spaceRight));
      let left = triggerRect.left;
      
      if (left + menuWidth > boundaryRight) {
        left = Math.max(boundaryLeft, boundaryRight - menuWidth);
      }
      if (left + menuWidth > boundaryRight) {
        menuWidth = boundaryRight - left;
      }
      if (left < boundaryLeft) {
        menuWidth = Math.min(menuWidth, window.innerWidth - 20);
        left = boundaryLeft;
      }
      
      menu.style.position = 'fixed';
      menu.style.top = (triggerRect.bottom) + 'px';
      menu.style.left = left + 'px';
      menu.style.width = menuWidth + 'px';
      menu.style.minWidth = '150px';
    };
    
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const isOpen = dropdownElement.classList.contains('is-open');
      
      document.querySelectorAll('[data-custom-dropdown].is-open').forEach(function(other) {
        if (other !== dropdownElement) {
          other.classList.remove('is-open');
        }
      });
      
      document.querySelectorAll('body > [data-dropdown-menu]').forEach(function(menuInBody) {
        if (menuInBody !== menu) {
          menuInBody.style.setProperty('opacity', '0', 'important');
          menuInBody.style.setProperty('visibility', 'hidden', 'important');
          menuInBody.style.setProperty('pointer-events', 'none', 'important');
        }
      });
      
      if (!isOpen) {
        const rect = trigger.getBoundingClientRect();
        
        document.body.appendChild(menu);
        
        menu.style.position = 'fixed';
        menu.style.top = Math.round(rect.bottom) + 'px';
        menu.style.left = Math.round(rect.left) + 'px';
        menu.style.width = Math.round(rect.width) + 'px';
        
        dropdownElement.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        
        menu.style.setProperty('transition', 'none', 'important');
        menu.style.setProperty('opacity', '1', 'important');
        menu.style.setProperty('visibility', 'visible', 'important');
        menu.style.setProperty('transform', 'translateY(0)', 'important');
        menu.style.setProperty('pointer-events', 'auto', 'important');
        menu.style.setProperty('display', 'block', 'important');
        
        // Set initial focus to selected option
        const selectedIndex = optionsArray.findIndex(function(opt) { return opt.classList.contains('is-selected'); });
        updateFocusedOption(selectedIndex >= 0 ? selectedIndex : 0);
        
        requestAnimationFrame(function() { menu.style.removeProperty('transition'); });
      } else {
        dropdownElement.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        updateFocusedOption(-1);
        menu.style.setProperty('opacity', '0', 'important');
        menu.style.setProperty('visibility', 'hidden', 'important');
        menu.style.setProperty('pointer-events', 'none', 'important');
        
        setTimeout(function() {
          if (menu.parentNode === document.body) {
            dropdownElement.appendChild(menu);
          }
        }, 200);
      }
      
      return false;
    }, true);
    
    options.forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.stopPropagation();
        const variantId = option.getAttribute('data-variant-id');
        const textElement = option.querySelector('.custom-dropdown__option-text');
        const variantText = textElement ? textElement.textContent.trim() : option.textContent.trim();
        const variantImage = option.getAttribute('data-variant-image');
        
        // Update selection state and aria-selected
        options.forEach(function(opt) { 
          opt.classList.remove('is-selected'); 
          opt.setAttribute('aria-selected', 'false');
        });
        option.classList.add('is-selected');
        option.setAttribute('aria-selected', 'true');
        
        const selectedText = trigger.querySelector('.custom-dropdown__selected-text');
        if (selectedText) selectedText.textContent = variantText;
        
        if (triggerColor) {
          const hex = option.getAttribute('data-color-metafield');
          const swatchImage = option.getAttribute('data-swatch-image');
          setColorCircle(triggerColor, hex, swatchImage);
        }
        
        nativeSelect.value = variantId;
        
        if (variantImage && productImage && variantImage !== productImage.src) {
          const img = new Image();
          img.onload = function() {
            productImage.src = variantImage;
            productImage.alt = productImage.alt.split(' - ')[0] + ' - ' + variantText;
          };
          img.src = variantImage;
        }
        
        const variantInput = document.getElementById(location + '-' + productId);
        if (variantInput) variantInput.value = variantId;
        
        dropdownElement.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        updateFocusedOption(-1);
        menu.style.setProperty('opacity', '0', 'important');
        menu.style.setProperty('visibility', 'hidden', 'important');
        menu.style.setProperty('pointer-events', 'none', 'important');
        
        // Return focus to trigger after selection
        trigger.focus();
        
        setTimeout(function() {
          if (menu.parentNode === document.body) {
            dropdownElement.appendChild(menu);
          }
        }, 200);
      });
    });
    
    const closeOnScroll = function(e) {
      if (!dropdownElement.classList.contains('is-open')) return;
      if (e && e.target && (e.target === menu || menu.contains(e.target))) return;
      
      dropdownElement.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      updateFocusedOption(-1);
      menu.style.setProperty('opacity', '0', 'important');
      menu.style.setProperty('visibility', 'hidden', 'important');
      menu.style.setProperty('pointer-events', 'none', 'important');
      
      setTimeout(function() {
        if (menu.parentNode === document.body) {
          dropdownElement.appendChild(menu);
        }
      }, 200);
    };
    
    window.addEventListener('scroll', closeOnScroll, true);
    window.addEventListener('resize', closeOnScroll);
  };
  
  function setupDropdownListeners() {
    if (!window.dropdownClickOutsideRegistered) {
      document.addEventListener('click', function(e) {
        const clickedTrigger = e.target.closest('[data-dropdown-trigger]');
        const clickedMenu = e.target.closest('[data-dropdown-menu]');
        
        if (clickedTrigger) return;
        if (clickedMenu) return;
        
        document.querySelectorAll('[data-custom-dropdown].is-open').forEach(function(dropdown) {
          dropdown.classList.remove('is-open');
          const trigger = dropdown.querySelector('[data-dropdown-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.removeAttribute('aria-activedescendant');
          }
          dropdown.querySelectorAll('.is-focused').forEach(function(opt) {
            opt.classList.remove('is-focused');
          });
        });
        
        document.querySelectorAll('body > [data-dropdown-menu]').forEach(function(menu) {
          menu.style.setProperty('opacity', '0', 'important');
          menu.style.setProperty('visibility', 'hidden', 'important');
          menu.style.setProperty('pointer-events', 'none', 'important');
        });
      }, true);
      window.dropdownClickOutsideRegistered = true;
    }
    
    if (!window.dropdownObserverRegistered && typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.hasAttribute && node.hasAttribute('data-custom-dropdown') && 
                  node.dataset.dropdownInitialized !== 'true') {
                window.initCustomVariantDropdown(node);
              }
              if (node.querySelectorAll) {
                node.querySelectorAll('[data-custom-dropdown]:not([data-dropdown-initialized="true"])').forEach(function(dropdown) {
                  window.initCustomVariantDropdown(dropdown);
                });
              }
            }
          });
        });
      });
      
      observer.observe(document.body, { childList: true, subtree: true });
      window.dropdownObserverRegistered = true;
    }
    
    document.querySelectorAll('[data-custom-dropdown]:not([data-dropdown-initialized="true"])').forEach(function(dropdown) {
      window.initCustomVariantDropdown(dropdown);
    });
  }
  
  // Event listeners can be added immediately (they wait for events)
  document.addEventListener('drawerOpen', function() {
    setTimeout(function() {
      document.querySelectorAll('[data-custom-dropdown]:not([data-dropdown-initialized="true"])').forEach(function(dropdown) {
        window.initCustomVariantDropdown(dropdown);
      });
    }, 100);
  });
  
  document.addEventListener('toggle-product-drawer', function() {
    setTimeout(function() {
      document.querySelectorAll('[data-custom-dropdown]:not([data-dropdown-initialized="true"])').forEach(function(dropdown) {
        window.initCustomVariantDropdown(dropdown);
      });
    }, 200);
  });
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDropdownListeners);
  } else {
    setupDropdownListeners();
  }
})();

